import React from "react";
import PageTemplate from "../components/template/PageTemplate";

const Contact = () => {
  return (
    <PageTemplate>
    <section className="page-content">
      <h1 className="page-heading">Contact Me</h1>
      <p>Let's connect! Feel free to reach out via email or social media.</p>
    </section>
    </PageTemplate>
  );
};

export default Contact;
